// source: pbtypes/gen/surface_scan/gps_helper_state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_body_gps_origin_pb = require('../../../pbtypes/gen/body/gps_origin_pb.js');
goog.object.extend(proto, pbtypes_gen_body_gps_origin_pb);
var pbtypes_gen_skills_gps_waypoint_pb = require('../../../pbtypes/gen/skills/gps_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_gps_waypoint_pb);
goog.exportSymbol('proto.surface_scan.GpsHelperState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.surface_scan.GpsHelperState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.surface_scan.GpsHelperState.repeatedFields_, null);
};
goog.inherits(proto.surface_scan.GpsHelperState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.surface_scan.GpsHelperState.displayName = 'proto.surface_scan.GpsHelperState';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.surface_scan.GpsHelperState.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.surface_scan.GpsHelperState.prototype.toObject = function(opt_includeInstance) {
  return proto.surface_scan.GpsHelperState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.surface_scan.GpsHelperState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.GpsHelperState.toObject = function(includeInstance, msg) {
  var f, obj = {
gpsPolygonList: jspb.Message.toObjectList(msg.getGpsPolygonList(),
    pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.toObject, includeInstance),
gpsWaypoint: (f = msg.getGpsWaypoint()) && pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.toObject(includeInstance, f),
globalMapGpsOrigin: (f = msg.getGlobalMapGpsOrigin()) && pbtypes_gen_body_gps_origin_pb.GpsOrigin.toObject(includeInstance, f),
overwriteGlobalMapGpsOriginZFromWorldTNavZ: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.surface_scan.GpsHelperState}
 */
proto.surface_scan.GpsHelperState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.surface_scan.GpsHelperState;
  return proto.surface_scan.GpsHelperState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.surface_scan.GpsHelperState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.surface_scan.GpsHelperState}
 */
proto.surface_scan.GpsHelperState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint;
      reader.readMessage(value,pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.deserializeBinaryFromReader);
      msg.addGpsPolygon(value);
      break;
    case 3:
      var value = new pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint;
      reader.readMessage(value,pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.deserializeBinaryFromReader);
      msg.setGpsWaypoint(value);
      break;
    case 2:
      var value = new pbtypes_gen_body_gps_origin_pb.GpsOrigin;
      reader.readMessage(value,pbtypes_gen_body_gps_origin_pb.GpsOrigin.deserializeBinaryFromReader);
      msg.setGlobalMapGpsOrigin(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverwriteGlobalMapGpsOriginZFromWorldTNavZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.surface_scan.GpsHelperState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.surface_scan.GpsHelperState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.surface_scan.GpsHelperState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.GpsHelperState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGpsPolygonList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.serializeBinaryToWriter
    );
  }
  f = message.getGpsWaypoint();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.serializeBinaryToWriter
    );
  }
  f = message.getGlobalMapGpsOrigin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_body_gps_origin_pb.GpsOrigin.serializeBinaryToWriter
    );
  }
  f = message.getOverwriteGlobalMapGpsOriginZFromWorldTNavZ();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * repeated skills.GpsWaypoint gps_polygon = 1;
 * @return {!Array<!proto.skills.GpsWaypoint>}
 */
proto.surface_scan.GpsHelperState.prototype.getGpsPolygonList = function() {
  return /** @type{!Array<!proto.skills.GpsWaypoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint, 1));
};


/**
 * @param {!Array<!proto.skills.GpsWaypoint>} value
 * @return {!proto.surface_scan.GpsHelperState} returns this
*/
proto.surface_scan.GpsHelperState.prototype.setGpsPolygonList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.skills.GpsWaypoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.GpsWaypoint}
 */
proto.surface_scan.GpsHelperState.prototype.addGpsPolygon = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.skills.GpsWaypoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.surface_scan.GpsHelperState} returns this
 */
proto.surface_scan.GpsHelperState.prototype.clearGpsPolygonList = function() {
  return this.setGpsPolygonList([]);
};


/**
 * optional skills.GpsWaypoint gps_waypoint = 3;
 * @return {?proto.skills.GpsWaypoint}
 */
proto.surface_scan.GpsHelperState.prototype.getGpsWaypoint = function() {
  return /** @type{?proto.skills.GpsWaypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint, 3));
};


/**
 * @param {?proto.skills.GpsWaypoint|undefined} value
 * @return {!proto.surface_scan.GpsHelperState} returns this
*/
proto.surface_scan.GpsHelperState.prototype.setGpsWaypoint = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.GpsHelperState} returns this
 */
proto.surface_scan.GpsHelperState.prototype.clearGpsWaypoint = function() {
  return this.setGpsWaypoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.GpsHelperState.prototype.hasGpsWaypoint = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional body.GpsOrigin global_map_gps_origin = 2;
 * @return {?proto.body.GpsOrigin}
 */
proto.surface_scan.GpsHelperState.prototype.getGlobalMapGpsOrigin = function() {
  return /** @type{?proto.body.GpsOrigin} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_body_gps_origin_pb.GpsOrigin, 2));
};


/**
 * @param {?proto.body.GpsOrigin|undefined} value
 * @return {!proto.surface_scan.GpsHelperState} returns this
*/
proto.surface_scan.GpsHelperState.prototype.setGlobalMapGpsOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.GpsHelperState} returns this
 */
proto.surface_scan.GpsHelperState.prototype.clearGlobalMapGpsOrigin = function() {
  return this.setGlobalMapGpsOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.GpsHelperState.prototype.hasGlobalMapGpsOrigin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool overwrite_global_map_gps_origin_z_from_world_t_nav_z = 4;
 * @return {boolean}
 */
proto.surface_scan.GpsHelperState.prototype.getOverwriteGlobalMapGpsOriginZFromWorldTNavZ = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.GpsHelperState} returns this
 */
proto.surface_scan.GpsHelperState.prototype.setOverwriteGlobalMapGpsOriginZFromWorldTNavZ = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


goog.object.extend(exports, proto.surface_scan);
